import { GlosaLogKeys, ILog, MensajesSalidaKeys } from "../interfaces/logger.interface";

const DETALLE_GLOSA: Record<GlosaLogKeys, string> = {
    WFI_INGRESO_PORTAL_ASESOR_INVERSION: 'INGRESA AL PORTAL DE ASESOR DE INVERSIÓN DE FONDOS MUTUOS',
};

const MENSAJES_SALIDA: Record<MensajesSalidaKeys, string> = {
  ASUNTO_INGRESO_PORTAL_ASESOR_INVERSION: 'HA INGRESADO CON ÉXITO AL PORTAL DE ASESOR DE INVERSIÓN DE FONDOS MUTUOS',
};


const generarDetalle = (detalle: string, rutCliente = '', rutAsesor?: string): string => {
  return rutAsesor
    ? `ASESOR CON [RUT ${rutAsesor}] ${detalle} PARA EL CLIENTE CON [RUT ${rutCliente}]`
    : `CLIENTE CON [RUT ${rutCliente}] ${detalle}`;
};

const mapearGlosaLogs = (rutCliente: string, rutAsesor?: string): Record<GlosaLogKeys, string> => {
  return (Object.keys(DETALLE_GLOSA) as GlosaLogKeys[]).reduce((acc, key) => {
    acc[key] = generarDetalle(DETALLE_GLOSA[key], rutCliente, rutAsesor);
    return acc;
  }, {} as Record<GlosaLogKeys, string>);
};

export const generarLog = (rutCliente: string, rutAsesor?: string): Record<GlosaLogKeys, ILog> => {
  const glosaLogs = mapearGlosaLogs(rutCliente, rutAsesor);
  return (Object.keys(DETALLE_GLOSA) as GlosaLogKeys[]).reduce((acc, key) => {
    acc[key] = { accion: key, glosa: glosaLogs[key] };
    return acc;
  }, {} as Record<GlosaLogKeys, ILog>);
};

export const mensajesSalida = (rutCliente: string, rutAsesor: string): Record<MensajesSalidaKeys, string> => {
  return Object.entries(MENSAJES_SALIDA).reduce((acc, [key, value]) => {
    acc[key as MensajesSalidaKeys] = generarDetalle(value, rutCliente, rutAsesor);
    return acc;
  }, {} as Record<MensajesSalidaKeys, string>);
};
